<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Email Orders Search</h2>
                    <AdminEmailSearch v-bind:searchParams="searchParams" v-bind:orders="orders"
                                        v-bind:loading="loading" v-bind:resultsCount="resultsCount"></AdminEmailSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="orders" style="width: 100%;"
                              class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="code" label="Email ID" width="100">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="100">
                        </el-table-column>
                        <el-table-column prop="created" label="Created" width="100" :formatter="formatDateDDMMYYYYCreatedNoneZ">
                        </el-table-column>
                        <el-table-column prop="sender" label="Sender">
                        </el-table-column>
                        <el-table-column prop="subject" label="Name">
                        </el-table-column>
                        <el-table-column prop="attachment" label="Artwork Name">
                        </el-table-column>
                        <!--<el-table-column prop="style" label="Fcode" width="120">-->
                        <!--</el-table-column>-->
                        <!--<el-table-column prop="stock" label="Finishing" width="540" class="text__wordwrap">-->
                        <!--</el-table-column>-->
                        <!--<el-table-column prop="quantity" label="Quantity" width="100">-->
                        <!--</el-table-column>-->
                        <el-table-column label="Download" width="100">
                            <template slot-scope="props">
                                <img class="layout__width-20px layout__position-center" v-on:click="downloadArtwork(props)"
                                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png">
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!--<Pagination v-bind:orders="orders" v-bind:start="start" v-bind:end="end"-->
                            <!--v-bind:pagination="pagination"></Pagination>-->

                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import AdminEmailSearch from '../../components/search/AdminEmailSearch';
    import {axios} from '@/mixins/Axios.js';
    import {pagination} from '@/mixins/Pagination.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Pagination from "../../components/Pagination.vue";

    export default {
        name: "bespokeOrdersAdmin",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            Pagination,
            AdminEmailSearch,
        },
        props: {
            view: ''
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                loading: false,
                searchParams: {
                    orderSource: 'BESPOKE',
                    orderSourceId: null,
                    orderStatus: 'ANY STATUS',
                    orderFreeText: '',
                    assignment: null,
                    territory: null,
                    top: 20,
                    pagination: 20,
                    skip: 0,
                    currentPage: 1,
                    salesDateRange: []
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        methods: {
            downloadArtwork(props) {

                console.log(props)

                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/EmailOrder/GetEmailPdfLink?WilliamOrderId=` + props.row.code

                Axios.get(url, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.downloadLink(event, response.data.result)
                        event.stopPropagation();
                    })
                    .catch(error => {
                        event.stopPropagation();
                    })
                event.stopPropagation();

            },
            resultsPerPage() {
                document.getElementById('getEmailOrdersPagination').click()
            },
            csv() {
                document.getElementById('downloadAllResults').click()
            }
        }
    };
</script>